"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FloatingBottomMenu = void 0;
var _floatingBottomMenu = _interopRequireDefault(require("./components/floating-bottom-menu"));
exports.FloatingBottomMenu = _floatingBottomMenu["default"];